/**
 * TiliaAPIError
 * @extends Error
 * @description
 * Parses the response object coming back from Tilia's API's to try and gather useful information
 * to display to the end-user.
 */
class TiliaAPIError extends Error {
  /**
   * constructor
   * @param {Response} response
   * @param {object} [info]
   * @param {object} [info.data] -- full json data payload from fetch response
   * @param {String} [info.message] -- sometimes a message comes from within the error response payload instead of statusText, in those cases it's parsed and passed in here
   * @param {Array<string>} [info.apiCodes] --  An array of error codes used for pulling localized message for the error(s) encountered
   */
  constructor(response, info) {
    // TODO: Massage the error messages from APIs either here or in `/proxy`
    // See: https://tiliajira.atlassian.net/browse/DEV-1082
    const message =
      response.statusText ||
      info?.message ||
      `Unknown error occurred. ${response.status ? `(${response.status})` : ""}`;
    super(message);

    this.name = "TiliaAPIError";
    this.status = response.status;
    this.response = response;
    this.data = info?.data || null;
    this.apiCodes = info?.errorCodes || null;
  }
}

export default TiliaAPIError;
